// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3X6eW","name":"ConsentHeader_name__35HWD","birthday":"ConsentHeader_birthday__1uksG","skeleton":"ConsentHeader_skeleton__3uyMc"};